/* eslint-disable max-len */
import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectFormStyles = makeStyles((theme) =>
  createStyles({
    form: {
      width: '100%'
    },

    accordionDetails: {
      flexDirection: 'column'
    },

    accordion: {
      boxShadow: theme.shadows[2],
      padding: '16px 0 16px 0',

      '&:first-child': {
        marginBottom: 48
      },

      '&:not(:first-child)': {
        margin: '48px 0'
      },

      '&:before': {
        display: 'none'
      },

      [theme.breakpoints.up(960)]: {
        maxWidth: '100%'
      }
    },

    checkboxLabel: {
      fontSize: 14
    },

    sup: {
      alignSelf: 'flex-end'
    },

    groupChip: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      width: '100%',

      '& > div': {
        marginBottom: 8,
        marginRight: 16
      }
    },

    chip: {
      maxWidth: '30%',
      overflow: 'hidden'
    },

    actions: {
      justifyContent: 'flex-end'
    },

    groupButton: {
      marginTop: '48px',
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'column',
      maxWidth: '100%',

      '& > button': {
        marginBottom: theme.spacing(2)
      },

      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',

        '& > button': {
          marginBottom: 0
        },

        '& > button:last-child': {
          marginLeft: theme.spacing(2)
        }
      }
    },

    groupButtonMobile: {
      width: 257,
      margin: 'auto',
      marginBottom: 63,
      display: 'flex',
      justifyContent: 'space-between'
    },

    draft: {
      width: '100%',

      [theme.breakpoints.up('sm')]: {
        width: 'auto',
        marginRight: 'auto'
      }
    },

    fileFormatHelperText: {
      whiteSpace: 'pre-wrap'
    },

    inputError: {
      border: '1px solid red'
    },

    editorTitle: {
      fontSize: 13,
      marginBottom: 14
    },

    editorValidationError: {
      '& .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred':
        {
          border: '1px solid red'
        },
      '& .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-focused':
        {
          border: '1px solid red'
        }
    },
    editorInput: {
      '& .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar': {
        borderRadius: '5px 5px 0 0'
      },
      '& .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline':
        {
          borderRadius: '0 0 5px 5px',
          [theme.breakpoints.up('sm')]: {
            minHeight: 206
          }
        }
    }
  })
)
